//hola
import React from 'react';
import '../../../styles/components/_bloglist.scss';
import laprensaaus from '../../../images/laprensaaus.JPG'
import meet from '../../../images/meet_skiper.jpg'
const newsArticles = [
  {
    title: "Robot submarino que explorará la Antártida",
    summary:
      "Descubre cómo un innovador robot submarino está listo para explorar las frías aguas antárticas y revolucionar la investigación polar.",
    image:
      meet ,
    url:
      "https://www.megatiempo.cl/sostenibilidad/5381-robot-submarino-que-explorara-la-antartica-28-03-2025.html",
  },
  {
    title:
      "Estudiantes UAI perfeccionan robot para exploración submarina con bajo impacto ambiental",
    summary:
      "Un grupo de estudiantes ha desarrollado un robot submarino que minimiza el impacto ambiental, marcando un avance en la exploración marina sustentable.",
    image:
      laprensaaus,
    url:
      "https://laprensaaustral.cl/2025/03/30/estudiantes-uai-perfeccionan-robot-para-exploracion-submarina-con-bajo-impacto-ambiental/",
  },
  {
    title:
      "Skiper: Cómo es la mantarraya, robot creado por estudiantes chilenos para explorar la Antártida",
    summary:
      "Conoce Skiper, la innovadora mantarraya robot diseñada por estudiantes chilenos para avanzar en la exploración de la Antártida.",
    image:
      "https://www.latercera.com/resizer/v2/QXXKE23YNZFZZJ3LGRRSFPTLH4.jpg?quality=80&smart=true&auth=9899c7ec5ba36aecb1f0dde34dc75b143f668aa6a3be2ef366dc409c48b7919d&width=790&height=444",
    url:
      "https://www.latercera.com/que-pasa/noticia/skiper-como-es-la-mantarraya-robot-creada-por-estudiantes-chilenos-para-explorar-la-antartica/",
  },
];

const NewsArticles = () => {
  const handleClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="news" className="news-section">
      <div className="container">
        <h2>News Articles</h2>
        <div className="grid">
          {newsArticles.map((article, index) => (
            <div
              className="news-card"
              key={index}
              onClick={() => handleClick(article.url)}
            >
              <img
                src={article.image}
                alt={article.title}
                className="news-image"
              />
              <div className="news-content">
                <h3>{article.title}</h3>
                <p>{article.summary}</p>
                <span className="read-more">Read More</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsArticles;